import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

// Initialize DataDog RUM
export const initDataDog = () => {
  if (
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_DATADOG_CLIENT_TOKEN &&
    process.env.REACT_APP_DATADOG_APPLICATION_ID
  ) {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: process.env.REACT_APP_DATADOG_SITE,
      service: 'padhai-pwa',
      env: process.env.NODE_ENV,
      version: process.env.REACT_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: true })],
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
    });
  }
};

// Log error to DataDog
export const logErrorToDataDog = (error, errorInfo, { source }) => {
  if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
    datadogRum.addError(error, {
      errorInfo,
      source: source || 'react-error-boundary',
      componentStack: errorInfo?.componentStack,
    });
  }
};
